import {
  TOGGLE_DRAWER
} from './mutation_types';

export default {
  [TOGGLE_DRAWER](state) {
    state.drawer = !state.drawer;
  }
};
